import { Observable } from "rxjs";
import NetworkService from "../network/networkService";
import { helperFunctions } from "../helper/helper";
import { AgTechQueryParam } from "../enums/AgTechQueryParams.enum";
import {
  ILocation,
  ILocationAllResponse,
  IRegionResponse,
} from "../models/ILocation.model";
import { URLConfig } from "../network/urlStore";
import { OdQueryParam } from "../enums";

export const getLocations = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<ILocationAllResponse> => {
  let url = URLConfig.getLocationMasterDataURL();

  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (locationResponse: unknown) => {
        if (locationResponse) {
          const locationsResponse =
            locationResponse as unknown as ILocationAllResponse;

          subscriber.next(locationsResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Locations master data", error);
      }
    );
  });
};

export const getLocationsNextPage = (
  nextPageURI: string
): Observable<ILocationAllResponse> => {
  let url = URLConfig.getLocationNextPageURl(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (locationResponse) => {
        if (locationResponse) {
          const locationsResponse =
            locationResponse as unknown as ILocationAllResponse;

          subscriber.next(locationsResponse);
        }

        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Locations master data", error);
      }
    );
  });
};

export const createLocation = (requestPayload: any): Observable<any> => {
  let url = URLConfig.getLocationMasterDataURL();

  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload).then(
      (locationResponse) => {
        if (locationResponse) {
          const locationsResponse =
            locationResponse as unknown as ILocationAllResponse;
          subscriber.next(locationsResponse);
        }
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a Location", error);
      }
    );
  });
};
export const getAllRegion = (): Observable<IRegionResponse> => {
  let url = URLConfig.getAllLocationRegionMasterDataURL();

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (locationResponse) => {
        if (locationResponse) {
          const locationsResponse =
            locationResponse as unknown as IRegionResponse;
          subscriber.next(locationsResponse);
        }
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a Location", error);
      }
    );
  });
};

export const getContentLengthForLocation = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getLocationMasterDataURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};

export const updateLocation = (
  seasonPayload: any,
  locationId: string
): Observable<any> => {
  let url = URLConfig.updateLocationMasterDataURL(locationId);

  return new Observable((subscriber) => {
    NetworkService.put(url, seasonPayload).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating seasonfield", error);
      }
    );
  });
};

export const deleteLocation = (
  locationId: string
): Observable<ILocationAllResponse> => {
  const url = URLConfig.updateLocationMasterDataURL(locationId);
  return new Observable((subscriber) => {
    NetworkService.delete(url).then(
      (res: unknown) => {
        const response = res as ILocationAllResponse;
        subscriber.next(response);
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while deleting location master data", error);
      }
    );
  });
};

export const getAllLocations = (
  queryParams?: Array<{ key: AgTechQueryParam | OdQueryParam; value: string[] }>
): Observable<ILocation[]> => {
  let allLocations: ILocation[] = [];

  return new Observable((subscriber) => {
    const errorHandler = (error: any) => {
      subscriber.error(error);
    };

    const responseHandler = (response: ILocationAllResponse) => {
      allLocations = [...allLocations, ...(response.locations || [])];

      if (response.nextPageUri) {
        getLocationsNextPage(response.nextPageUri).subscribe({
          next: responseHandler,
          error: errorHandler,
        });
      } else {
        subscriber.next(allLocations);
        subscriber.complete();
      }
    };

    getLocations(queryParams).subscribe({
      next: responseHandler,
      error: errorHandler,
    });
  });
};